// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import LightBulb12CircleFilled from './LightBulb12CircleFilled.tsx';
import LightBulb20 from './LightBulb20.tsx';
import LightBulb20Filled from './LightBulb20Filled.tsx';
import LightBulb20CircleFilled from './LightBulb20CircleFilled.tsx';
import LightBulb24 from './LightBulb24.tsx';
import LightBulb24Filled from './LightBulb24Filled.tsx';
import LightBulb24CircleFilled from './LightBulb24CircleFilled.tsx';
import LightBulb40 from './LightBulb40.tsx';
import LightBulb40Filled from './LightBulb40Filled.tsx';
import LightBulb48 from './LightBulb48.tsx';
import LightBulb48Filled from './LightBulb48Filled.tsx';

type LightBulbProps = {
    variation:
        | '12CircleFilled'
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    LightBulb12CircleFilled,
    LightBulb20,
    LightBulb20Filled,
    LightBulb20CircleFilled,
    LightBulb24,
    LightBulb24Filled,
    LightBulb24CircleFilled,
    LightBulb40,
    LightBulb40Filled,
    LightBulb48,
    LightBulb48Filled,
};

const LightBulb: FC<LightBulbProps> = ({ variation, ...props }) => {
    const variationKey = `LightBulb${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"LightBulb" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default LightBulb;
